import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Drawer({ as, className, children, variant, ...rest }) {
    const Component = as ?? "dialog";
    return (_jsx(Component, { className: classNames("cvr-drawer", { "cvr-drawer--right": variant === "right" }, { "cvr-drawer--left": variant === "left" }, className), closedby: "any", ...rest, children: children }));
}
